import React from 'react';
import { useSelector } from 'react-redux';
import { Arrow, Container, FieldName, FieldValue, Row, Subtitle, Title } from './DTOrderAddressInfoWidget.styles';
import {
  getShippingAddressOfSelectedOrder,
  getSelectedOrderNumber,
  getOrderingSystem,
} from '../../../../selectors/tools';
import { camelToSnakeCase } from '../../../../util/util';

const DTOrderAddressInfoWidget = () => {
  const orderNumber = useSelector(getSelectedOrderNumber);
  const orderShippingAddress = useSelector(getShippingAddressOfSelectedOrder);
  const orderSystem = useSelector(getOrderingSystem);

  const getAddressValue = (key) => {
    if (orderSystem === 'shopify') {
      if (key === 'region') {
        return orderShippingAddress['province'];
      }

      return orderShippingAddress[camelToSnakeCase(key)] ?? '';
    }

    if (key === 'region') {
      return orderShippingAddress['region'] ?? orderShippingAddress['state'] ?? '';
    }

    return orderShippingAddress[key] ?? '';
  };

  const fieldsMap = {
    Customer: `${getAddressValue('firstName')} ${getAddressValue('lastName')}`,
    'Address line 1': orderShippingAddress.address1,
    'Address line 2': orderShippingAddress.address2,
    City: orderShippingAddress.city,
    'State/Region': getAddressValue('region'),
    'Zip Code': orderShippingAddress.zip,
    Country: orderShippingAddress.country,
  };

  return (
    <Container>
      <Title>Order Number: {orderNumber}</Title>
      <Subtitle>Shipping address:</Subtitle>
      {Object.entries(fieldsMap).map(([key, value]) => {
        return (
          <Row key={key}>
            <FieldName>{key}</FieldName>
            <Arrow alt="arrow" src="/images/arrows/arrow-widget.svg" />
            <FieldValue>{value}</FieldValue>
          </Row>
        );
      })}
    </Container>
  );
};

export default DTOrderAddressInfoWidget;
